import { cn } from '@/utils/cn';

interface NotificationBadgeProps {
  isRoot?: boolean;
  count: number | undefined;
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({ isRoot = false, count = 0 }: NotificationBadgeProps) => {
  if (!count) {
    return null;
  }

  const displayCount = count > 9 ? '9+' : count.toString();

  return (
    <div
      className={cn(
        'flex items-center justify-center w-3 h-3 lg:w-4 lg:h-4 rounded-full bg-blue-100',
        isRoot && 'absolute top-[2px] right-[4px] lg:top-[5px] lg:right-[5px]',
        !isRoot && 'w-4 h-4',
        count > 9 && 'right-0.5 w-4 lg:w-5 rounded-md lg:rounded-lg',
      )}
    >
      <span className={cn('leading-none text-[8px] lg:text-[11px] font-medium text-white', !isRoot && 'text-[11px]')}>{displayCount}</span>
    </div>
  );
};

export default NotificationBadge;
